import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=33bf183a&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=ts"
export * from "./FeedbackModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf183a",
  null
  
)

export default component.exports